import React from 'react'
import Header from '../Header'

function Not_Authorised() {
    document.body.style.backgroundColor = "white"
    

    return (
        <div style={{backgroundColor:"white"}}>
        <Header />
        <div style={{height:"80vh"}} className="notabody">            
        <h1 style={{textAlign:"center",position:"absolute",top:"45vh",left:"45vw",fontSize:"2rem",color:"#008069"}}> Not Authorised</h1>
        </div>
        </div>
    )
}

export default Not_Authorised